// E8 F8-4.3 — the active persona the SPA is acting as. Persisted in sessionStorage (so it's cleared on
// tab close and by sign-out, useSignOut). The key (single-sourced in app/axios/const, also imported by
// the persona-header interceptor) + positive-integer contract are shared with that interceptor
// (app/axios/logikspark.ts), which sends the value as X-LogikSpark-Persona-Id; the E9 middleware
// authoritatively re-validates it against the JWT oid, so this is a convenience for routing the request,
// not a trust boundary.
export { ACTIVE_PERSONA_USER_ID_KEY } from '../../app/axios/const'
import { ACTIVE_PERSONA_USER_ID_KEY } from '../../app/axios/const'

// The active persona's User id, or null when unset / malformed. Mirrors the interceptor's guard:
// 0 (the reserved platform id), negatives, NaN and absent all read as "no persona".
export function getActivePersonaUserId(): number | null {
  const raw = sessionStorage.getItem(ACTIVE_PERSONA_USER_ID_KEY)
  if (!raw) {
    return null
  }
  const id = Number.parseInt(raw, 10)
  return Number.isInteger(id) && id > 0 ? id : null
}

export function setActivePersonaUserId(userId: number): void {
  sessionStorage.setItem(ACTIVE_PERSONA_USER_ID_KEY, String(userId))
}

export function clearActivePersona(): void {
  sessionStorage.removeItem(ACTIVE_PERSONA_USER_ID_KEY)
}
